<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-md-12">
        <div class="card card-top-line">
          <ValidationObserver v-slot="{ passes }">
            <div class="header">
              <h2>
                {{ $route.name == "category-add" ? "Add" : "Edit" }} Category
              </h2>
            </div>
            <div class="body">
              <form @submit.prevent="passes(documentSubmit)" id="basic-form">
                <div class="body">
                  <ValidationProvider
                    name="main_category"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <div
                      class="form-group form-select single-multiselect select-option-custom"
                      :class="{
                        errors: errors.length && !document.main_category,
                        success: document.main_category,
                      }"
                    >
                      <span class="float-label">
                        <label for="main_category" class="control-label">
                          Main Category*
                        </label>
                        <multiselect
                          placeholder=""
                          v-model="document.main_category"
                          :show-labels="false"
                          :options="['Top']"
                        ></multiselect>
                        <div class="line"></div>
                        <i
                          class="fa fa-times"
                          v-if="errors.length && !document.main_category"
                        ></i>
                        <i
                          class="fa fa-check"
                          v-if="document.main_category"
                        ></i>
                      </span>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider
                    name="news_category"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <div
                      class="form-group"
                      :class="{
                        errors: errors.length && !document.news_category,
                        success: document.news_category,
                      }"
                    >
                      <span class="float-label">
                        <input
                          type="text"
                          v-model="document.news_category"
                          class="form-control"
                          placeholder="News Category"
                        />
                        <label for="cms" class="control-label">
                          News Category*
                        </label>
                        <div class="line"></div>
                        <i
                          class="fa fa-times"
                          v-if="errors.length && !document.news_category"
                        ></i>
                        <i
                          class="fa fa-check"
                          v-if="document.news_category"
                        ></i>
                      </span>
                    </div>
                  </ValidationProvider>
                  <div
                    class="d-flex justify-content-between align-items-center w-25"
                  >
                    <label class="mb-0" for="customSwitchstatus">Status</label>
                    <div class="custom-switch success-error-bg">
                      <input
                        type="checkbox"
                        class="custom-switch-input"
                        id="customSwitchstatus"
                        v-model="document.status"
                      />
                      <label
                        class="custom-switch-label pr-4 pl-5"
                        for="customSwitchstatus"
                      >
                        <span class="custom-switch-text1">Active</span>
                        <span class="custom-switch-text2">InActive</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex flex-column flex-md-row justify-content-center"
                >
                  <b-button
                    variant="secondary btn-mw"
                    size="lg"
                    @click="$router.back()"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    type="submit"
                    variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                    size="lg"
                  >
                    Submit
                  </b-button>
                </div>
              </form>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const BreadCrumb = require("@/components/BreadCrumb.vue").default;
const { ValidationObserver, ValidationProvider } = require("vee-validate");
export default {
  name: "AddOrEditNewsCategory",
  components: {
    BreadCrumb,
    Multiselect: () => import("vue-multiselect"),
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      document: {
        news_category: "",
        main_category: "",
        status: true,
      },
    };
  },
  methods: {
    documentSubmit() {
      console.log(this.document);
    },
  },
  mounted() {
    if (this.$route.name == "category-edit") {
      this.document = {
        main_category: "Top",
        news_category: "New category",
        status: true,
      };
    }
  },
};
</script>
